// The demo bar's small icons, under the names DemoStageBar.vue uses. Each is a
// vocabulary meaning (ADR 0096) at the size and stroke weight the bar has always drawn;
// the progress ring is a drawing and lives in demoStageRing.ts.
import { defineComponent, h } from 'vue';
import { LumiIcon, type LumiIconName } from '@lumi/ui';

function glyph(componentName: string, name: LumiIconName, size: number, strokeWidth: number) {
  return defineComponent({
    name: componentName,
    render: () => h(LumiIcon, { name, width: size, height: size, 'stroke-width': strokeWidth }),
  });
}

// A chevron here always opens something (the persona picker, the journey card).
export const ChevronIcon = glyph('DemoStageChevronIcon', 'expand', 12, 2);
export const CheckIcon = glyph('DemoStageCheckIcon', 'confirm', 16, 2.5);
export const BlockedIcon = glyph('DemoStageBlockedIcon', 'blocked', 16, 2.5);
// "Demo beenden": the step from the demo into a live workspace.
export const RocketIcon = glyph('DemoStageRocketIcon', 'call-to-action', 15, 2);
// "Leave the demo".
export const DoorIcon = glyph('DemoStageDoorIcon', 'sign-out', 15, 2);
export const InfoIcon = glyph('DemoStageInfoIcon', 'info', 18, 2);
export const CloseIcon = glyph('DemoStageCloseIcon', 'remove', 14, 2);
export const UserPlusIcon = glyph('DemoStageUserPlusIcon', 'new-hire', 15, 2);
export const RefreshIcon = defineComponent({
  name: 'DemoStageRefreshIcon',
  props: { spinning: { type: Boolean, default: false } },
  render() {
    return h(LumiIcon, { name: 'refresh', width: 14, height: 14, 'stroke-width': 2, class: this.spinning ? 'demo-stage__spin' : undefined });
  },
});
